export default __webpack_public_path__ + "static/media/ico-minus.a5fc8efc.svg";